import { useHistory } from "react-router-dom";

import NewMeetupForm from "../components/meetups/NewMeetupForm";

function NewMeetupPage() {
  const history = useHistory();

  function addMeetupHandler(meetupData) {
    // We can see data over here
    // https://console.firebase.google.com/project/react-getting-started-cece4/database/react-getting-started-cece4-default-rtdb/data
    fetch(
      "https://react-getting-started-cece4-default-rtdb.firebaseio.com/meetups.json",
      {
        method: "POST",
        body: JSON.stringify(meetupData),
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then(() => {
        history.replace("/");
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }

  return (
    <section>
      <h1>Add New Meetup</h1>
      <NewMeetupForm onAddMeetup={addMeetupHandler} />
    </section>
  );
}

export default NewMeetupPage;
